export enum OrderPanelActions {
    SET_ORDER_DETAILS = "setOrderDetails",
    TOGGLE_ORDER_PANEL = "toggleOrderPanel",
    TOGGLE_SYNC_ORDER_PANEL = "toggleSyncOrderPanel",
    TOGGLE_SMS_PANEL = "toggleSMSPanel",
    SET_ORDER_COMMENTS = "setOrderComments",
    SET_ORDER_HISTORY = "setOrderHistory",
    SET_ACTIVE_TAB = "setActiveOrderTab",
    ADD_NEW_COMMENT = "addNewComment",
    SET_ORDER_EDITING = "setOrderEditing",
    ADD_NEW_ORDER = "addNewOrder",
    SET_ORDER_CORRECTING = "setOrderCorrecting",
    TOGGLE_CUO_SPLITS_PANEL = "toggleCuoSplitsPanel"
  }